<template>
	<div class="row">
		<div class="col-12 col-lg-3 col-xl-2">
			<img src="../../../public/img/logo-dark_cut.png" class="img-fluid">
		</div>
		<div class="col offset-2">
			<div class="d-flex justify-content-between">
				<router-link to="/admin/bottles">Flaschen</router-link>
				<router-link to="/admin/customers">Kunden</router-link>
				<router-link to="/admin/users">Benutzer</router-link>
				<span><!-- placeholder --></span>
				<router-link to="/logout">Logout</router-link>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: "Navigation"
	}
</script>

<style scoped>

</style>
